import React from 'react'
import '../../App.css'
import {Link} from 'react-router-dom';

export default function Track(props) {
    const {track} = props;
    return (
        <div className="col-md-6">
            <div className="card mb-4 shadow-sm">
                <div className="card-body">
                    <h5 style={{fontFamily: 'Source Sans Pro', fontWeight: 'bold'}}>{track.track_name}</h5>
                    <p className="card-text">
                        <strong><i className="fa fa-play-circle" aria-hidden="true"></i>   {track.artist_name}</strong>
                    </p>
                    <Link to={`lyrics/track/${track.track_id}`} className="btn btn-block" style={{backgroundColor: '#2B2B52', color: '#fff'}}>
                        <strong><i className="fa fa-info-circle" aria-hidden="true"></i>  View Lyrics</strong>
                    </Link>
                </div>
            </div>
        </div>
    ) 
}
